/**
 * True when the JWT `exp` claim is present and already in the past.
 * Tokens without `exp` are not treated as expired here.
 */
export function isJwtExpired(
  decoded: { exp?: unknown } | null | undefined,
  nowMs: number = Date.now(),
): boolean {
  const exp = decoded?.exp;
  if (typeof exp !== "number" || !Number.isFinite(exp)) return false;
  return exp * 1000 < nowMs;
}
